import React from "react";

export const DesembolsoContext = React.createContext();